import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    adornment: {
        marginTop: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            paddingLeft: 0,
        },
        "& .MuiInputAdornment-root": {
            padding: theme.spacing(5, 4),
            backgroundColor: theme.palette.emteria.background.paperDeep,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
        },
        pageTitleBox: {
            display: "flex",
        },
    },
    tableLayout: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    toolbar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        flexShrink: 0,
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "auto",
        overscrollBehavior: "contain",
    },
    tableContainerNoScroll: {
        overflowY: "hidden",
    },
    alertBox: {
        display: "inline-block",
        marginTop: theme.spacing(3),
    },
    popoverContentCotainer: {
        display: "flex",
        flexDirection: "column",
    },
}));
